import { Injectable } from '@angular/core';
import {AngularFirestore} from "@angular/fire/compat/firestore";
import firebase from "firebase/compat/app";
import {Observable} from "rxjs";
import {EducationInduction} from "./induction.model";

@Injectable({
  providedIn: 'root'
})
export class InductionService {
  private collection = this.firestore.collection<EducationInduction>('educationInduction');

  constructor(private firestore: AngularFirestore) {}

  create(data: EducationInduction): Promise<any> {
    const payload: EducationInduction = {
      ...data,
      createdAt: firebase.firestore.FieldValue.serverTimestamp() as any,
      updatedAt: firebase.firestore.FieldValue.serverTimestamp() as any,
    };
    return this.collection.add(payload);
  }

  getDataById(id: string): Observable<EducationInduction | undefined> {
    return this.collection.doc<EducationInduction>(id).valueChanges({ idField: 'id' });
  }

  getAll(): Observable<EducationInduction[]> {
    return this.collection.valueChanges({ idField: 'id' });
  }
  update(id: string, data: Partial<EducationInduction>): Promise<void> {
    const payload = {
      ...data,
      updatedAt: firebase.firestore.FieldValue.serverTimestamp()
    };
    return this.collection.doc(id).update(payload);
  }

  deleteRow(id: string): Promise<void> {
    return this.collection.doc(id).delete();
  }
}
